import { imageService } from "../_services/image.service";
import { localstorageSession } from "../_helpers/localstorage-session";
import { stat } from "fs";

const images_session = JSON.parse(localStorage.getItem("imageselection"));
const initialStateDefault = () => {
  return {
    imageselection: images_session!=null ? images_session : [],
  };
};
const initialResponsivity = () => {
  return localStorage.getItem("grid-responsivity") || '2';
}

export const image = {
  namespaced: true,
  state: {
    image: {},
    images: null,
    modeSelection: false,
    previews_images: [],
    filter: 'date', //  a-z or date
    filter_responsivity: initialResponsivity(),
    multiSelectImg: initialStateDefault().imageselection,
    modalDelImg: false
  },
  getters: {
    getModalDelImg(state) {
      return state.modalDelImg;
    },
    getFilter(state) {
      return state.filter;
    },
    getFilterResponsivity(state) {
      return state.filter_responsivity;
    },
    getImg: async state => {
      return state.image;
    },
    getImages: async state => {
      return state.images;
    },
    getModeSelection: state => {
      return state.modeSelection;
    },
    getImgProject: (state)  => uuid_project =>  {
      if (state.images != null) {
        const images = state.images.filter(element => element.project == uuid_project);
        return images;
      } else
        return null;
    },
    getPreviews(state) {
      return state.previews_images;
    },
    getMultiSelectImg(state) {
      return state.multiSelectImg;
    }
  },
  mutations: {
    setModalDelImg(state, status) {
      state.modalDelImg = status;
    },
    setFilterResponsivity(state, responsivity) {
      state.filter_responsivity = responsivity;
      localStorage.setItem("grid-responsivity", responsivity);
    },
    setPreviews(state, previews) {
      if (Array.isArray(previews)) {
        state.previews_images.unshift(...previews);
        // localStorage.setItem("previews", JSON.stringify(previews));
      }
    },
    setFilter(state, number) {
      state.filter = number;
    },
    addImg(state, newImg) {
      if (state.images === null) return;
      state.images.push(newImg);
      // localstorageSession("images", state.images);
      // localstorageSession("image", newImg);
    },
    setModeSelection(state, newMode) {
      state.modeSelection = newMode;
    },
    setImg(state, newImg) {
      state.image = newImg;
      // localstorageSession("image", state.image);
      // localstorageSession("image", newImg);
    },
    setImages(state, images) {
      state.images = images;
      // localstorageSession("images", state.images);
      // localstorageSession("images", images);
    },
    async deleteMedia(state, uuid) {
      let index = state.images.findIndex(item => item.uuid === uuid);
      if (index !== -1) {
        state.images.splice(index, 1);
      }
      localstorageSession("images", state.images);
      index = state.multiSelectImg.indexOf(uuid);
      if (index !== -1)
        state.multiSelectImg.splice(index, 1);
      localStorage.setItem("imageselection", JSON.stringify(state.multiSelectImg));
    },
    initPreviews(state) {
      state.previews_images = [];
    },
    deleteMediaPreview(state, index) {
      state.previews_images.splice(index, 1);
    },
    setMultiSelectImg(state, imgUuid) {
      state.multiSelectImg.push(imgUuid);

      localStorage.setItem("imageselection", JSON.stringify(state.multiSelectImg));
    },
    unsetMultiSelectImg(state, imgUuid) {
      let index = state.multiSelectImg.indexOf(imgUuid);
      state.multiSelectImg.splice(index, 1);
      localStorage.setItem("imageselection", JSON.stringify(state.multiSelectImg));
    },
    emptyMultiSelectImg(state) {
      state.multiSelectImg = [];
      localStorage.setItem("imageselection", JSON.stringify(state.multiSelectImg));
    }
  },
  actions: {
    savePreviews({ commit }, images) {
      commit("setPreviews", images);
    },
    initPreviews({ commit }) {
      commit("initPreviews");
    },
    getImg: async ({ dispatch, commit }, uuid) => new Promise((resolve, reject) => {
        imageService
          .getImage(uuid)
          .then(img => {
            commit("setImg", img);
            // commit("setModeSelection", true);
            resolve(img);
          })
          .catch(error => {
            console.error('function getImg : ', error);
            // commit("loginFailure", error);
            dispatch("alert/error", error, { root: true });
          })
      }),
    async postImg({ dispatch, commit }, data) {
      imageService
        .createImage(data)
        .then(img => {

          commit("addImg", img);
          commit("setImg", img);

        })
        .catch(error => {
          console.error('function postImg : ', error);
          // commit("loginFailure", error);
          dispatch("alert/error", error, { root: true });
        });
    },
    deleteMedia({ dispatch, commit, getters }, uuid) {
      imageService
        .deleteMedia(uuid)
        .then(media => {
          commit("deleteMedia", uuid);
        })
        .catch(error => {
          // commit("loginFailure", error);
          dispatch("alert/error", error, { root: true });
        });
    },
    getImages({ dispatch, commit, getters }) {
      return new Promise((resolve, reject) => {
        imageService
        .getImages()
        .then(images => {
          commit("setImages", images.results);
          resolve(images);
        })
        .catch(error => {

          // commit("loginFailure", error);
          dispatch("alert/error", error), { root: true };
        });
      })
    },
    modeSelection({ commit }, mode) {
      commit("setModeSelection", mode);
    },
    filter({ commit }, number) {
      commit("setFilter", number);
    },
    filterResponsivity({ commit }, responsivity) {
      commit("setFilterResponsivity", responsivity);
    },
    deleteOneMediaPreview({ commit }, index) {
      commit("deleteMediaPreview", index);
    },
    updateMedia: ({ commit, dispatch }, data) => new Promise((res, rej) => {
      imageService
        .updateMedia(data)
        .then(response => {
          res(response);
        })
        .catch(error => { rej(error) });
    }),
    updateMediaName({ commit, dispatch }, [uuid, newName]) {
      return new Promise((resolve, reject) => {
        imageService.updateMediaName(uuid, newName).then(() => {
          resolve();
        });
      });
    },
    updateMediaProject({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        imageService.updateMediaProject(data).then(() => {
          resolve();
        });
      });
    }
  }
};